import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../axiosInstance"; // Import Axios instance
import "../pages/addcomment.css";

const AddComment = () => {
  const [comment, setComment] = useState("");
  const [popupMessage, setPopupMessage] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const viewKey = searchParams.get("view_key");

  const handleCommentSubmit = async () => {
    if (!comment.trim()) {
      setPopupMessage("Please enter a comment.");
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      setPopupMessage("Authentication token is missing.");
      return;
    }

    if (!viewKey) {
      setPopupMessage("View key is missing.");
      return;
    }

    try {
      const response = await axiosInstance.post(
        `/pifir/fdbk/?view_key=${viewKey}`,
        { comment },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const data = response.data;
      if (data && data.feedback_collection === 0) {
        setPopupMessage("Thank you for your feedback!");
      } else {
        setPopupMessage(
          data.msg || "Failed to submit comment. Please try again."
        );
      }
    } catch (error) {
      console.error("Error submitting comment:", error);
      setPopupMessage("Something went wrong. Please try again.");
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h4>
        <button className="backbtn" onClick={() => navigate(-2)}>
          Back
        </button>
      </h4>
      <h3>Please Enter Your Comment</h3>
      <input
        className="submitbtn"
        type="text"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        placeholder="Enter your comment"
      />
      <button onClick={handleCommentSubmit} style={{ padding: "8px 15px" }}>
        Submit
      </button>

      {/* Popup Message */}
      {popupMessage && (
        <div className="popupdiv">
          <p>{popupMessage}</p>
          <button
            onClick={() => setPopupMessage(null)}
            style={{ padding: "5px 10px" }}
          >
            OK
          </button>
        </div>
      )}
    </div>
  );
};

export default AddComment;
